import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { BPProfilesService } from '../../bp-profiles.service';
import { SurveyDataService } from '../../../../shared/survey/survey-data.service';

@Component({
  selector: 'bp-profiles-survey',
  template: `
    <survey-questions-wrapper [countryId]="countryId" [companyId]="companyId" [companyCountryId]="companyCountryId" [workflowType]="'${SurveyDataService.WORKFLOW_BP}'"></survey-questions-wrapper>
  `,
  styleUrls: ['./bp-profiles-survey.scss'],
  encapsulation: ViewEncapsulation.None
})
export class BPProfilesSurveyComponent implements OnInit {
  public countryId:number;
  public companyId:number;
  public companyCountryId:number;

  constructor(
    private bpProfilesService:BPProfilesService
  ) {
    /**/
  }

  public ngOnInit():void {
    this.countryId = this.bpProfilesService.activeProfile?.country?.id;
    this.companyId = this.bpProfilesService.activeProfile?.company?.id;
    this.companyCountryId = this.bpProfilesService.activeProfile?.companyCountryId;
  }
}